import styled from "styled-components";

/* The picker spans the modal (its body has no padding): the shades, then the hue bar */
export const ColorPicker = styled.div`
  .react-colorful {
    width: 100%;
    height: auto;
  }
  .react-colorful__saturation {
    height: 330px;
    border: none;
    border-radius: 0;
  }
  .react-colorful__last-control {
    height: 8px;
    margin: 20px;
    border-radius: 10px;
  }
  .react-colorful__saturation-pointer {
    width: 18px;
    height: 18px;
    border-width: 4px;
  }
  .react-colorful__hue-pointer {
    width: 16px;
    height: 16px;
    border-width: 4px;
  }
`;

/* The hex field, on the footer's left */
export const ColorField = styled.div`
  flex: 1;
  min-width: 0;
`;
